type UnknownArrayOrObject = unknown[] | Record<string, unknown>;

export const getDirtyFieldValues = (
  dirtyFields: UnknownArrayOrObject,
  values: UnknownArrayOrObject,
) =>
  Object.fromEntries(
    Object.keys(dirtyFields).map((field) => [
      field,
      values[field as keyof typeof dirtyFields],
    ]),
  );
